import _ from 'lodash';
import Immutable from 'seamless-immutable';

/**
 * Создание field
 */
export function createField(obj) {
  return {
    [obj.field]: {
      type: 'field',
      field: obj.field,
      title: obj.title || 'Field name',
      inValue: obj.value, // дублиреум тк должно быть идиентичным до change
      value: obj.value,
      validate: obj.validate || [],
      errors: obj.errors || []
    }
  };
}

/**
 * Создание fieldsArr
 */
export function createFieldsArr(obj) {
  return {
    [obj.field]: {
      type: 'fieldsArr',
      field: obj.field || 'noNameField',
      title: obj.title || 'Field arr name',
      inValue: obj.value,
      value: obj.value || [],
      validate: obj.validate || [],
      errors: obj.errors || []
    }
  };
}

/**
 * Создание fieldManual, генерирует поле для формы чз внутренню, настраиваемую converterValueToSend функцию
 */
export function createFieldManual(obj) {
  return {
    [obj.field]: {
      type: 'fieldManual',
      field: obj.field,
      title: obj.title || 'Field name',
      inValue: obj.value,
      value: obj.value || [],
      converterValueToSend: obj.converterValueToSend || null,
      validate: obj.validate || [],
      errors: obj.errors || []
    }
  };
}

/**
 * Создание fieldsArr
 */
export function createFieldsObj(obj) {
  return {
    type: 'fieldsObj',
    field: obj.field,
    title: obj.title || 'Field obj name',
    inValue: obj.value,
    value: obj.value || {},
    validate: obj.validate || [],
    errors: obj.errors || []
  };
}

/**
 * Создание fieldFromArr
 */
export function createFieldFromArr(obj) {
  return {
    type: 'fieldFromArr',
    field: obj.field,
    title: obj.title || 'Field name',
    inValue: obj.value,
    value: obj.value || [],
    validate: obj.validate || [],
    errors: obj.errors || []
  };
}

/**
 * Генерация названий field детей динамических форм (fieldsArr) для уникализации.Чтобы была возможность привязать ref
 * либо составлять объект для отправки на сервер.
 * Например:
 * time_target_0_weekdays
 * time_target_0_times_0
 * time_target_0_times_1
 * time_target_1_weekdays
 * time_target_1_times_0
 * time_target_1_times_1
 */
export function fieldsRenamingFromDepth(state) {
  const handlerFieldArr = (field, depth = [], parent) => {
    if (_.isArray(field)) {
      return _.map(field, (item, index) => {
        if (parent.type && parent.type === 'fieldsArr') {
          return handlerFieldArr(item, [...depth, ...[index]], field);
        }
        return handlerFieldArr(item, depth, field);
      });
    } else if (_.isObject(field)) {
      if (
        field.type &&
        (field.type === 'fieldFromArr' || field.type === 'field')
      ) {
        // eslint-disable-next-line no-param-reassign
        field.field = depth.join('_');
        return field;
      }

      return _.mapValues(field, (item, key) => {
        if (
          _.isObject(item) &&
          item.type &&
          (item.type === 'fieldsArr' ||
            item.type === 'fieldsObj' ||
            item.type === 'field')
        ) {
          return handlerFieldArr(item, [...depth, key], field);
        }
        return handlerFieldArr(item, depth, field);
      });
    }
    return field;
  };

  // eslint-disable-next-line no-param-reassign
  state.fields = _.mapValues(state.fields, item => {
    if (item.type === 'fieldsArr') {
      // eslint-disable-next-line no-param-reassign
      item.value = item.value.map((arrItem, index) =>
        handlerFieldArr(arrItem, [item.field, index], state.fields)
      );
    }
    return item;
  });
  return state;
}

/**
 * Добавление элемента в fieldFromArr
 */
export function addToFieldsArr(state, dotPath, fieldObj) {
  const stateMutable = Immutable.asMutable(state, {
    deep: true
  });
  const concatVal = _.get(stateMutable, dotPath).value.concat([fieldObj]);
  _.set(stateMutable, dotPath.concat(['value']), concatVal);
  _.set(stateMutable, dotPath.concat(['errors']), []);
  return state.merge(fieldsRenamingFromDepth(stateMutable), { deep: true });
}

/**
 * Удаление элемента из fieldFromArr
 */
export function dropToFieldsArr(state, dotPath, index) {
  const stateMutable = Immutable.asMutable(state, {
    deep: true
  });
  const newVal = _.get(stateMutable, dotPath).value;

  // Удаляем все ошибки валидации
  newVal.map(arrFieldItem => {
    if (stateMutable.errors) {
      delete stateMutable.errors[arrFieldItem.field];
    }
    _.set(arrFieldItem, ['errors'], []);
    return arrFieldItem;
  });
  _.pullAt(newVal, [index]);
  _.set(stateMutable, dotPath.concat(['value']), newVal);
  return state.merge(fieldsRenamingFromDepth(stateMutable), { deep: true });
}

/**
 * Очиска value в fieldFromArr
 */
export function clearFieldArr(state, dotPath) {
  const stateMutable = Immutable.asMutable(state, {
    deep: true
  });
  _.set(stateMutable, dotPath.concat(['value']), []);
  return state.merge(stateMutable, { deep: true });
}

/**
 * Замена значения по пути
 */
export function changeFieldByPath(state, arrPath, value) {
  const field = Immutable.getIn(state, arrPath);
  return Immutable.setIn(
    state,
    arrPath,
    Immutable.merge(field, value, { deep: true })
  );
}

/**
 * Создание объекта ошибки
 */
export function createErrorObject(fieldName, errorMessage) {
  return {
    field: fieldName,
    message: errorMessage
  };
}

/**
 * Создание объекта валидации
 */
export function createValidateObject(typeValidate, conditionValidate = null) {
  return {
    type: typeValidate,
    condition: conditionValidate
  };
}

/**
 * Возвращает состояния с новым значением поля формы
 */
export function storeSetFieldValue(
  state,
  field,
  newValue,
  clearFieldErrors = true
) {
  const newField = {};
  newField[field] = { ...state.fields[field], ...{ value: newValue } };
  if (clearFieldErrors) {
    newField[field].errors = [];
  }
  return state.merge({ fields: { ...state.fields, ...newField } });
}

/**
 * Возвращает состояния с восстановленными полями формы
 */
export function storeRecoveryFieldValues(state, fields, recoveryFunc = {}) {
  const newFields = {};
  Object.keys(fields).map(objectKey => {
    if (recoveryFunc[objectKey]) {
      const value = recoveryFunc[objectKey](fields[objectKey]);
      newFields[objectKey] = { value, inValue: value };
    } else {
      let value = fields[objectKey];
      if (typeof value === 'number' && value % 1 === 0) {
        value = value.toString();
      }
      if (state.fields[objectKey]) {
        newFields[objectKey] = { value, inValue: value };
      }
    }
    return null;
  });

  const result = state.merge(
    { hasRecoveredFields: true, fields: newFields },
    { deep: true }
  );
  return result.merge(
    fieldsRenamingFromDepth(Immutable.asMutable(result, { deep: true }))
  );
}

/**
 * Клиентская валидация полей. Пробегает по всем полям валидирует их если в них есть условия валидации.
 */
export function storeFieldsValidate(state) {
  const allErrors = [];
  const validate = field => {
    const newField = field;
    if (newField.validate && newField.validate.length > 0) {
      newField.errors = [];
      newField.validate.map(validateFunk => {
        if (_.isFunction(validateFunk)) {
          const errorMessage = validateFunk(state, newField);
          if (errorMessage) {
            const newError = createErrorObject(newField.field, errorMessage);
            newField.errors = [...newField.errors, newError];
            allErrors.push(newError);
          }
        }
        return null;
      });
    }
    if (_.isArray(field.value)) {
      _.map(field.value, fieldVal => validate(fieldVal));
    } else if (_.isObject(field.value)) {
      _.mapValues(field.value, fieldVal => validate(fieldVal));
    }
    return newField;
  };

  const mutableStateFields = Immutable.asMutable(state.fields, {
    deep: true
  });
  _.map(mutableStateFields, field => validate(field));
  return state
    .merge({ fields: mutableStateFields }, { deep: true })
    .setIn(['errors'], _.groupBy(allErrors, 'field'));
}

/**
 * Присваевает ошибки полям из забора ошибок, например от сервера.
 * [{
 *  field: 'fieldName',
 *  message: 'errorMessage'
 * }]
 * Возвращает состояние с присвоенными ошибками
 */
export function storeSetFieldsErrors(state, errors) {
  const newFields = {};
  const errorsByFields = _.groupBy(errors, 'field');
  Object.keys(errorsByFields).map(objectKey => {
    const value = errorsByFields[objectKey];
    if (state.fields[objectKey]) {
      newFields[objectKey] = { errors: value };
    }
    return null;
  });
  return state.merge(
    { fields: newFields, errors: _.groupBy(errors, 'field') },
    { deep: true }
  );
}

/**
 * Удаляет все ошибки из состояния
 */
export function clearErrors(state) {
  const newFields = {};
  Object.keys(state.fields).map(objectKey => {
    if (state.fields[objectKey]) {
      newFields[objectKey] = { errors: [] };
    }
    return null;
  });
  return state.merge({ fields: newFields, errors: [] }, { deep: true });
}

/**
 * Возвращает поля запроса формы reducer
 */
export function getForm(state) {
  return _.mapValues(state.fields, v => {
    if (v.type === 'fieldGroup') {
      return _.mapValues(state.fields);
    }
    return v.value;
  });
}

/**
 * Возвращает объект для запроса на сервер
 */
export function generateForm(fields) {
  const generateItem = field => {
    switch (field.type) {
      case 'field':
      case 'fieldFromArr':
        return field.value;
      case 'fieldsObj':
      case 'fieldsArr':
        return generateForm(field.value);
      case 'fieldManual':
        return field.converterValueToSend(field.value);
      default:
        return fields;
    }
  };
  if (_.isArray(fields)) {
    return _.map(fields, field => generateItem(field));
  } else if (_.isObject(fields)) {
    return _.mapValues(fields, field => generateItem(field));
  }
  return null;
}

/**
 * TODO Отвязать и удалить! (SignIn)
 * Возврачает информацию по ошибкам формы
 */
export function hasErrors(state) {
  return state.error.length > 0;
}

export function hasErrorsByField(state, field) {
  return state && state.errors[field];
}

export function getAllFirstErrorsByFields(state) {
  return Object.keys(state.errors).map(key => state.errors[key][0]);
}

export function getAllErrorsByField(state, field) {
  return state.errors[field];
}

export function getFirstErrorByField(state, field) {
  if (state.errors[field]) {
    return state.errors[field][0];
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/reducerHalpers/formFields.js